export default {
  label: 'CPF',
  hint: 'Votre banque a besoin de votre CPF pour ce paiement. Nous le transmettons et ne le conservons pas.',
  invalid: "Ce n'est pas un CPF valide. Vérifiez les 11 chiffres.",
};
